import { render, staticRenderFns } from "./PdfDetailApi.vue?vue&type=template&id=1838dce6&scoped=true"
import script from "./PdfDetailApi.vue?vue&type=script&lang=js"
export * from "./PdfDetailApi.vue?vue&type=script&lang=js"
import style0 from "./PdfDetailApi.vue?vue&type=style&index=0&id=1838dce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1838dce6",
  null
  
)

export default component.exports